import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ extension, help, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('image-input')
    child.attrs.extension = extension
    this.children = [child]
    if (help) {
      this.children.push({
        component: 'el-alert',
        attrs: {
          showIcon: true,
          closable: false,
          title: help
        }
      })
    }
  }
}
